// extracted by mini-css-extract-plugin
export default {"cell":"ActorCell_cell__3XF2E","avatar":"ActorCell_avatar__EarD4","robotAvatar":"ActorCell_robotAvatar__rZmoa","name":"ActorCell_name__g1foC"};